export default __webpack_public_path__ + "static/maker-7df5051e72fca292645da3b0b529f2ea.svg";